import angular from 'angular';
import lmiCalculator from './lmiCalculator';

export default angular
  .module('components.lmiCalculator', [])
  .component('lmiCalculator', lmiCalculator).name;
